import _ from 'lodash';

export const trimLeft = (str: string, remove: string) =>
  str ? (str.startsWith(remove) ? str.slice(1, str.length) : str) : '';

export const trimRight = (str: string, remove: string) =>
  str ? (str.endsWith(remove) ? str.slice(0, -1) : str) : '';

export const trim = (str: string, remove: string) => trimLeft(trimRight(str, remove), remove);

export const firstUpperCase = (str: string) => str?.charAt(0).toUpperCase() + str?.slice(1);

export const firstLowerCase = (str: string) => str?.charAt(0).toLowerCase() + str?.slice(1);

export const isNonEmptyString = (str: string) =>
  str !== undefined && str !== null && str !== '' && typeof str === 'string';

export const escape = (text: string): string => _.escape(text);

export const isString = (value: unknown): value is string =>
  typeof value === 'string' || value instanceof String;
